/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/overlays/info-overlay - Copy',['require','core/overlay-screen'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var OverlayScreen = require('core/overlay-screen');

  /*****************************************************************************************************************///}

  var InfoOverlay = OverlayScreen.extend({

  /////////////
  // METHODS /{
  /////////////

    onShow: function()
    {
      this.finish();
    },

  /*****************************************************************************************************************///}

  });

  return InfoOverlay;

});

